export default __webpack_public_path__ + "static/media/roundabout-left.9a7149ab.svg";